import axios from 'axios';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MenuPage from './MenuPage';

const { ace } = window;

const WebboardPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token } = useSelector((state) => state.AuthReducer);

    const [id, setId] = useState('');
    const [editor, setEditor] = useState(null);


    useEffect(() => {
        handleInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleInit = async () => {
        const url = `https://ihongss.com/api/member/file_qa.json`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });
        // console.log(data);

        if (data.status === 200) {
            var editor1 = ace.edit("editor1", {
                theme: "ace/theme/eclipse",
                mode: "ace/mode/java",
                maxLines: Infinity,
                wrap: true,
                /* fontFamily : 'Nanum Gothic', */
                fontSize: "16px",
                autoScrollEditorIntoView: true,
                showPrintMargin: false,
                keyboardHandler: "ace/keyboard/vscode",
            });

            editor1.setValue(data.doc.filedata);
            editor1.gotoLine(0, 0);

            setId(data.doc._id);
            setEditor(editor1);
        }
    };




    const handleSave = async () => {
        const url = `https://ihongss.com/api/member/file_data_update.json`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const body = { id: id, data: editor.getValue() };

        const { data } = await axios.put(url, body, { headers });
        // console.log(data);
        if (data.status === 200) {
            alert('저장되었습니다.');
        }
        else if (data.status < 0) {
            dispatch({ type: 'logout' });
            navigate(`/`);
        }
    };



    return (
        <div>
            <div className="card flex justify-content-center"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    background: '#f0f2f5',
                    paddingTop: '5px',
                    paddingBottom: '2px',
                }}
            >
                <div>
                    <MenuPage />
                </div>

                <div style={{ marginTop: '5px' }}>
                    <Button onClick={handleSave} size="small" style={{ width: 'auto' }} severity="success">저장하기</Button>&nbsp;
                    <span style={{ color: "red" }}> 내용 입력 후 저장하기 버튼을 눌러 주세요.</span>
                </div>

                <hr />
            </div>


            <div className="container">
                <div className="row">
                    <div id="editor1"></div>
                </div>
            </div>

            <footer>
                <div className="container">
                    <div className="row">
                        <p className="copyright text-muted">2016 &copy; ihongss.com</p>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default WebboardPage;